<template>
  <div class="c-searchRecruiting">
    <DSwitch
      v-model="innerValue"
      true-value="1"
      false-value="0"
      is-animation-waiting
    >
      満枠非表示
    </DSwitch>
  </div>
</template>
<script>
import DSwitch from '~/components/atoms/DS2/DSwitch'
export default {
  name: 'SearchRecruiting',
  components: { DSwitch },
  props: {
    value: {
      type: [Boolean, String],
      required: true
    }
  },
  computed: {
    innerValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.c-searchRecruiting {
  display: flex;
  color: $ds2-color-gray-900;
  letter-spacing: 0.05em;
  font-size: 13px;
}
</style>
